import {
    getfilterSetCanSeeCompletedActionType,
    getfilterSetCanSeeHiddenActionType,
    getfilterSetCanSeeProjectActionType,
    getfilterSetCannotSeeProjectsActionType
} from "../../actions/filterAction";
const initialState = {
    CanSeeCompleted: false,
    CanSeeHidden: false,
    CannotSeeProjectIds: [],
};
export function canSeeCompleted(state, action) {
    if (!action) {
        return state;
    }
    if (action.canSee === state.CanSeeCompleted) {
        return state;
    }
    return {
        ...state,
        CanSeeCompleted: action.canSee
    };
}

export function canSeeHidden(state, action) {
    if (!action) {
        return state;
    }
    if (action.canSee === state.CanSeeHidden) {
        return state;
    }
    return {
        ...state,
        CanSeeHidden: action.canSee
    };
}

export function canSeeProject(state, action) {
    try {
        if (!action || !action.id) {
            return state;
        }
        if (action.canSee) {
            if (!state.CannotSeeProjectIds.find(id => id === action.id)) {
                return state;
            }
            return {
                ...state,
                CannotSeeProjectIds: state.CannotSeeProjectIds.filter(id => id !== action.id)
            };
        } else {
            if (state.CannotSeeProjectIds.find(id => id === action.id)) {
                return state;
            }
            return {
                ...state,
                CannotSeeProjectIds: [...state.CannotSeeProjectIds, action.id]
            };
        }
    } catch (exception) {
        console.log("Error in filterReducer - canSeeProject function: " + exception);
    }
    
}

export function cannotSeeProjects(state, action) {
    if (!action || !action.ids) {
        return state;
    }
    if (state.CannotSeeProjectIds === action.ids) {
        return state;
    }
    return {
        ...state,
        CannotSeeProjectIds: action.ids
    };
}

export function getFilterReducer(feature) {
    return function (state = initialState, action) {
        if (!action) { return state; }
        switch (action.type) {
            case getfilterSetCanSeeCompletedActionType(feature):
                return canSeeCompleted(state, action);
            case getfilterSetCanSeeHiddenActionType(feature):
                return canSeeHidden(state, action);
            case getfilterSetCanSeeProjectActionType(feature):
                return canSeeProject(state, action);
            case getfilterSetCannotSeeProjectsActionType(feature):
                return cannotSeeProjects(state, action);
            default:
                return state;
        }
    };
}

